import { Link } from "react-router-dom";
import { FiCamera } from "react-icons/fi";

// text wordmark used in the header and footer
export default function Logo({ className = "" }) {
  return (
    <Link
      to="/"
      className={`flex items-center gap-x-2 group ${className}`}
      aria-label="Camera Haus home">
      <FiCamera className="text-2xl text-brand transition-transform group-hover:-rotate-6" />
      <span className="text-xl font-bold uppercase tracking-tight leading-none text-ink">
        Camera<span className="text-brand"> Haus</span>
      </span>
    </Link>
  );
}
